import Event from '../domain/Event.js';

let MYEFC_AUTH_COOKIE_NAME = 'myEfcCookieAuth';

class LinkAccountHandler {

  constructor(controller, linkAccountValidator, requestBuilder, httpService, trackingService, cookieUtils, utils) {

    this.controller = controller;
    this.linkAccountValidator = linkAccountValidator;
    this.requestBuilder = requestBuilder;
    this.httpService = httpService;
    this.trackingService = trackingService;
    this.cookieUtils = cookieUtils;
    this.utils = utils

  }

  handleSubmit(requestToken, emailAddress, password) {

    this.controller.startActionInProgress();

    this.controller.setState({
      formInProgress: 'LINK_ACCOUNT'
    });

    this.linkAccountValidator.validate(requestToken, emailAddress, password);

    let linkAccountRequest = this.requestBuilder.getLinkAccountRequest(requestToken, emailAddress, password);

    return this.httpService.put(linkAccountRequest)
      .then((response) => {

        this.cookieUtils.set(MYEFC_AUTH_COOKIE_NAME, response.data.access_token, {domain: this.utils.getCookieDomain(), path: '/'});
        this.trackingService.submitEvent(Event.LINK_ACCOUNT);
        this.controller.handleSuccess(response.data);

        return response;
      });

  }

}

export default LinkAccountHandler;



// WEBPACK FOOTER //
// ./src/library/handlers/LinkAccountHandler.js